import { showPickupNotification } from './ui/pickupNotification.js';

export function scheduleVictory(game) {
  game.state = 'victory';
  game.audio.play('victoryStinger');
  setTimeout(() => {
    game.menuCtl.showVictory();
  }, 900);
  game.audio.stopMusic();
}

export async function advanceRoom(game, fragmentAfterRooms) {
  if (game._advancing) return;
  game._advancing = true;
  game.spawnRuntime?.stop();
  const nextIdx = game.roomIndex + 1;

  // Draft opens AFTER clearing certain rooms (so before entering next room)
  if (fragmentAfterRooms.includes(game.roomIndex + 1)) {
    game.state = 'draft';
    const hand = game.fragments.drawHand(3);
    if (hand.length > 0) {
      const pickedId = await game.draftUI.show(hand);
      const picked = game.fragments.resolveHand(hand, pickedId, game.player);
      game.audio.play('fragmentPick', { rate: 1.06 });
      game.audio.play('itemPickup', { rate: 1.14 });
      game.hud.setFragments([...game.player.fragments]);
      if (picked) {
        game.toast(`+ ${picked.name.toUpperCase()}`);
        showPickupNotification({
          icon: `public/assets/icons/fragments/${picked.id}.png`,
          label: 'Obtained',
          itemName: picked.name || picked.id,
          rarity: 'legendary',
        });
      }
    }
    game.state = 'playing';
  }

  game.roomIndex = nextIdx;
  game.transitionPostprocessToRoom?.(game.roomIndex + 1);
  game._clearEnemiesAndProjectiles();
  game._clearShards();
  game._clearAmmoPickups();
  game._clearWeaponPickups();
  game._clearGroundWeaponPickups();
  game._clearLootPickups();
  game._clearPlayerMines();
  if (game.room) { game.room.dispose(); game.room = null; }
  game._buildCurrentRoom();
  game._updateFogOfWar();
  game._advancing = false;
}

export function handleRoomClearedRewards(game, roomNumber) {
  game._roomClearBonus(roomNumber);
}
